import { YFlags } from '../y/types';

export type LPermission = 'admin.accounting.manage' | 'admin.bookings.view' | 'admin.bookings.manage' | 'admin.cities.manage' | 'admin.economy.manage' | 'admin.economy.view' | 'admin.email.manage' | 'admin.email.view' | 'admin.event_tags.manage' | 'admin.events.manage' | 'admin.events.view' | 'admin.giftcards.manage' | 'admin.giftcards.view' | 'admin.pages.manage' | 'admin.pdf.manage' | 'admin.permissions.manage' | 'admin.permissions.view' | 'admin.producers.manage' | 'admin.purchases.manage' | 'admin.routes.manage' | 'admin.statistics.view' | 'admin.system.manage' | 'admin.users.manage' | 'admin.users.view' | 'admin.venues.manage' | 'admin.video.manage' | 'admin.translations.view' | 'admin.translations.manage';

export interface LPermissionSpec {
    key: string;
    name: string;
    view: boolean;
    manage: boolean;
    experiment?: boolean;
}

export const l_permission_specs: LPermissionSpec[] = [{
    key: 'admin.accounting',
    name: 'Accounting',
    view: false,
    manage: true,
    experiment: true
}, {
    key: 'admin.bookings',
    name: 'Bookings',
    view: true,
    manage: true,
}, {
    key: 'admin.cities',
    name: 'Cities',
    view: false,
    manage: true,
}, {
    key: 'admin.data_definition',
    name: 'Data Definition',
    view: true,
    manage: false,
    experiment: true
}, {
    key: 'admin.economy',
    name: 'Economy',
    view: true,
    manage: true,
}, {
    key: 'admin.email',
    name: 'Emails',
    view: true,
    manage: true,
}, {
    key: 'admin.event_tags',
    name: 'Event tags',
    view: false,
    manage: true,
}, {
    key: 'admin.events',
    name: 'Events',
    view: true,
    manage: true,
}, {
    key: 'admin.giftcards',
    name: 'Gift cards',
    view: true,
    manage: true,
}, {
    key: 'admin.pages',
    name: 'Pages',
    view: false,
    manage: true,
}, {
    key: 'admin.pdf',
    name: 'PDF',
    view: false,
    manage: true,
}, {
    key: 'admin.permissions',
    name: 'Permissions',
    view: true,
    manage: true,
}, {
    key: 'admin.producers',
    name: 'Producers',
    view: false,
    manage: true,
}, {
    key: 'admin.purchases',
    name: 'Purchases',
    view: false,
    manage: true,
}, {
    key: 'admin.routes',
    name: 'Routes',
    view: false,
    manage: true,
}, {
    key: 'admin.statistics',
    name: 'Statistics',
    view: true,
    manage: false,
}, {
    key: 'admin.system',
    name: 'System',
    view: false,
    manage: true,
    experiment: true,
}, {
    key: 'admin.translations',
    name: 'Translations',
    view: true,
    manage: true,
}, {
    key: 'admin.users',
    name: 'Users',
    view: true,
    manage: true,
}, {
    key: 'admin.venues',
    name: 'Venues',
    view: false,
    manage: true,
}, {
    key: 'admin.video',
    name: 'Video',
    view: false,
    manage: true,
}];

const key_to_name = Object.fromEntries(l_permission_specs.map(s => [s.key, s.name]));

export function lPermissionsDescription(ps: YFlags<LPermission>) {
    const by_key: { [key: string]: string } = {};

    for(const p in ps) {
        if(!ps[p as LPermission]) continue;
        const dot = p.lastIndexOf('.');
        if(dot < 0) continue;
        const key = p.substring(0, dot);
        const kind = p.substring(dot + 1);
        if(kind == 'manage' || (kind == 'view' && by_key[key] != 'manage'))
            by_key[key] = kind;
    }

    const descriptions: string[] = [];
    for(const key in by_key) {
        const name = key_to_name[key];
        if(!name) continue;
        descriptions.push((by_key[key] == 'manage' ? 'Manage ' : 'View ') + name);
    }
    return descriptions.join(', ');
}
